import { css } from '@emotion/core';
import { IToken } from '../../shared/contexts/styleContext';

export const pendingItemStyle = (tokens: IToken) => css`
    padding: ${tokens.spacings.small};
    border-bottom: 1px solid rgba(0, 0, 0, 0.1);
`;
